import StandardDeductionsPage from '@playground/features/dictionary/StandardDeductionsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/standard-deductions'
)({
  component: StandardDeductionsPage,
})
